import { render, staticRenderFns } from "./TicketEdit.vue?vue&type=template&id=4e04bead&scoped=true&"
import script from "./TicketEdit.vue?vue&type=script&lang=js&"
export * from "./TicketEdit.vue?vue&type=script&lang=js&"
import style0 from "./TicketEdit.vue?vue&type=style&index=0&id=4e04bead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e04bead",
  null
  
)

export default component.exports